// Top universities worldwide
export const universities = [
  // United States - Top Universities
  "Harvard University",
  "Stanford University",
  "Massachusetts Institute of Technology (MIT)",
  "California Institute of Technology (Caltech)",
  "University of Chicago",
  "Princeton University",
  "Yale University",
  "Columbia University",
  "University of Pennsylvania",
  "Johns Hopkins University",
  "Northwestern University",
  "Duke University",
  "University of California, Berkeley",
  "University of California, Los Angeles (UCLA)",
  "University of Michigan",
  "Cornell University",
  "University of Washington",
  "New York University (NYU)",
  "University of California, San Diego",
  "University of Wisconsin-Madison",
  "University of Illinois Urbana-Champaign",
  "Georgia Institute of Technology",
  "University of Texas at Austin",
  "University of North Carolina at Chapel Hill",
  "University of Minnesota",
  "Boston University",
  "Purdue University",
  "University of Southern California",
  "Ohio State University",
  "University of California, Davis",
  "University of California, Santa Barbara",
  "University of Maryland",
  "University of Pittsburgh",
  "University of Florida",
  "Arizona State University",
  "Michigan State University",
  "University of Virginia",
  "Pennsylvania State University",
  "Rutgers University",
  "University of Arizona",
  "Indiana University Bloomington",
  "University of Colorado Boulder",
  "University of California, Irvine",
  "Texas A&M University",
  "Washington University in St. Louis",
  "Brown University",
  "Dartmouth College",
  "Vanderbilt University",
  "Rice University",
  "Emory University",
  "Carnegie Mellon University",
  "University of Notre Dame",
  "Georgetown University",
  "University of Rochester",
  "Case Western Reserve University",
  "Tufts University",
  "University of California, Santa Cruz",
  "University of Miami",
  "University of California, Riverside",
  "University of Delaware",
  "Northeastern University",
  "University of Iowa",
  "University of Connecticut",
  "University of Oregon",
  "University of Georgia",
  "University of Massachusetts Amherst",
  "Virginia Tech",
  "University of Utah",
  "University of Kansas",
  "Iowa State University",
  "Syracuse University",
  "University of Tennessee",
  "University of Kentucky",
  "University of Oklahoma",
  "University of Missouri",
  "University of Nebraska-Lincoln",
  "University of Arkansas",
  "University of South Carolina",
  "University of New Hampshire",
  "University of Vermont",
  "University of Rhode Island",
  "University of Maine",
  "University of Alabama",
  "Auburn University",
  "Louisiana State University",
  "University of Mississippi",
  "Mississippi State University",
  "University of South Florida",
  "Florida State University",
  "University of Central Florida",
  "Clemson University",
  "North Carolina State University",
  "University of Cincinnati",
  "University of Louisville",
  "University of Houston",
  "Southern Methodist University",
  "Tulane University",
  "Baylor University",
  "Texas Tech University",
  "University of Nevada, Las Vegas",
  "University of New Mexico",
  "University of Wyoming",
  "University of Montana",
  "University of Idaho",
  "University of Alaska Fairbanks",
  "University of Hawaii at Manoa",
  "Oregon State University",
  "Washington State University",
  "Colorado State University",
  "Utah State University",
  "Arizona State University",
  "New Mexico State University",
  "Oklahoma State University",
  "Kansas State University",
  "University of North Dakota",
  "South Dakota State University",
  "University of South Dakota",
  "North Dakota State University",
  "University of Nebraska Omaha",
  "Creighton University",
  "Drake University",
  "Marquette University",
  "DePaul University",
  "Loyola University Chicago",
  "University of Illinois Chicago",
  "Illinois Institute of Technology",
  "University of Wisconsin-Milwaukee",
  "University of Minnesota Duluth",
  "University of Missouri-Kansas City",
  "University of Missouri-St. Louis",
  "Saint Louis University",
  "University of Memphis",
  "University of Alabama at Birmingham",
  "University of Alabama in Huntsville",
  "University of Southern Mississippi",
  "University of North Texas",
  "University of Texas at Dallas",
  "University of Texas at Arlington",
  "University of Texas at San Antonio",
  "University of Texas at El Paso",
  "University of Texas Rio Grande Valley",
  "Texas State University",
  "Sam Houston State University",
  "University of Louisiana at Lafayette",
  "Louisiana Tech University",
  "University of New Orleans",
  "University of Arkansas at Little Rock",
  "University of Central Arkansas",
  "University of West Florida",
  "Florida Atlantic University",
  "Florida International University",
  "University of North Florida",
  "University of South Alabama",
  "Georgia State University",
  "Georgia Southern University",
  "Kennesaw State University",
  "University of North Carolina at Charlotte",
  "University of North Carolina at Greensboro",
  "East Carolina University",
  "Appalachian State University",
  "Old Dominion University",
  "George Mason University",
  "Virginia Commonwealth University",
  "James Madison University",
  "University of Maryland, Baltimore County",
  "Towson University",
  "University of Delaware",
  "Drexel University",
  "Temple University",
  "Villanova University",
  "University of Pittsburgh",
  "Duquesne University",
  "West Virginia University",
  "Marshall University",
  "Ohio University",
  "Miami University",
  "Kent State University",
  "Bowling Green State University",
  "University of Toledo",
  "University of Akron",
  "Cleveland State University",
  "Wright State University",
  "Ball State University",
  "Indiana University-Purdue University Indianapolis",
  "Western Michigan University",
  "Central Michigan University",
  "Eastern Michigan University",
  "Oakland University",
  "Wayne State University",
  "Grand Valley State University",
  "Northern Illinois University",
  "Southern Illinois University",
  "Illinois State University",
  "Western Illinois University",
  "Eastern Illinois University",
  "Northern Iowa University",
  "University of Wisconsin-Green Bay",
  "University of Wisconsin-Oshkosh",
  "University of Wisconsin-Eau Claire",
  "University of Wisconsin-La Crosse",
  "University of Wisconsin-Stevens Point",
  "University of Wisconsin-Stout",
  "University of Wisconsin-Whitewater",
  "University of Wisconsin-River Falls",
  "University of Wisconsin-Superior",
  "University of Wisconsin-Platteville",
  "University of Wisconsin-Parkside",
  "Minnesota State University, Mankato",
  "St. Cloud State University",
  "Winona State University",
  "Bemidji State University",
  "University of Minnesota Morris",
  "University of Minnesota Crookston",

  // US Liberal Arts Colleges
  "Amherst College",
  "Williams College",
  "Swarthmore College",
  "Pomona College",
  "Wellesley College",
  "Bowdoin College",
  "Carleton College",
  "Middlebury College",
  "Haverford College",
  "Claremont McKenna College",
  "Davidson College",
  "Vassar College",
  "Washington and Lee University",
  "Colby College",
  "Colgate University",
  "Hamilton College",
  "Grinnell College",
  "Wesleyan University",
  "Barnard College",
  "Bates College",
  "University of Richmond",
  "Bryn Mawr College",
  "College of the Holy Cross",
  "Macalester College",
  "Colorado College",
  "Kenyon College",
  "Oberlin College",
  "Scripps College",
  "Bucknell University",
  "Pitzer College",
  "Mount Holyoke College",
  "Lafayette College",
  "Occidental College",
  "Skidmore College",
  "Trinity College",
  "Union College",
  "Franklin & Marshall College",
  "Connecticut College",
  "Dickinson College",
  "Gettysburg College",
  "Rhodes College",
  "Sewanee: The University of the South",
  "Whitman College",
  "Denison University",
  "DePauw University",
  "Furman University",
  "St. Olaf College",
  "Centre College",
  "Lawrence University",
  "Wabash College",
  "Wheaton College",
  "College of Wooster",
  "Berea College",
  "St. Lawrence University",
  "Spelman College",
  "Morehouse College",
  "Howard University",
  "Xavier University of Louisiana",
  "Florida A&M University",
  "North Carolina A&T State University",
  "Hampton University",
  "Tuskegee University",
  "Claflin University",
  "Dillard University",
  "Fisk University",
  "Reed College",
  "Sarah Lawrence College",
  "Bennington College",
  "Bard College",
  "Hampshire College",
  "Goucher College",
  "Earlham College",
  "Beloit College",
  "Knox College",
  "Kalamazoo College",
  "Hendrix College",
  "Lewis & Clark College",
  "Willamette University",
  "Muhlenberg College",
  "Ursinus College",
  "Hobart and William Smith Colleges",
  "Juniata College",
  "Susquehanna University",
  "St. John's College",
  "College of Saint Benedict and Saint John's University",
  "Gustavus Adolphus College",
  "Augustana College",
  "Illinois Wesleyan University",
  "Wittenberg University",
  "Ohio Wesleyan University",
  "College of William & Mary",
  "University of Mary Washington",
  "New College of Florida",
  "St. Mary's College of Maryland",
  "SUNY Geneseo",
  "Ramapo College of New Jersey",
  "The College of New Jersey",
  "University of Minnesota Morris",
  "University of North Carolina at Asheville",
  "St. Mary's College of California",
  "Westmont College",
  "Whittier College",
  "University of Puget Sound",
  "Whitworth University",
  "Pacific Lutheran University",
  "Seattle University",
  "University of Portland",
  "Gonzaga University",
  "Santa Clara University",
  "Loyola Marymount University",
  "Chapman University",
  "Mills College",
  "Rollins College",
  "Stetson University",
  "Eckerd College",
  "Agnes Scott College",
  "Hollins University",
  "Randolph-Macon College",
  "Randolph College",
  "Sweet Briar College",
  "Roanoke College",
  "Washington College",
  "McDaniel College",
  "St. Mary's College of Maryland",
  "Lycoming College",
  "Allegheny College",
  "Washington & Jefferson College",
  "Westminster College",
  "Grove City College",
  "Albion College",
  "Hope College",
  "Calvin University",
  "Alma College",
  "Hillsdale College",
  "Coe College",
  "Cornell College",
  "Luther College",
  "Wartburg College",
  "Central College",
  "Simpson College",
  "Concordia College",
  "St. Olaf College",
  "Macalester College",
  "Carleton College",
  "Gustavus Adolphus College",
  "St. John's University",
  "College of Saint Benedict",
  "University of St. Thomas",
  "Hamline University",
  "Augsburg University",
  "Bethel University",
  "St. Catherine University",

  // Community colleges
  "Santa Monica College",
  "De Anza College",
  "Valencia College",
  "Miami Dade College",
  "Foothill College",
  "Santa Barbara City College",
  "Pasadena City College",
  "Irvine Valley College",
  "Orange Coast College",
  "Diablo Valley College",
  "City College of San Francisco",
  "Laney College",
  "Berkeley City College",
  "College of Alameda",
  "Merritt College",
  "Chabot College",
  "Las Positas College",
  "Ohlone College",
  "Mission College",
  "West Valley College",
  "San Jose City College",
  "Evergreen Valley College",
  "Cabrillo College",
  "Monterey Peninsula College",
  "Hartnell College",
  "Gavilan College",
  "Cañada College",
  "College of San Mateo",
  "Skyline College",
  "City College of New York",
  "Borough of Manhattan Community College",
  "LaGuardia Community College",
  "Queensborough Community College",
  "Kingsborough Community College",
  "Bronx Community College",
  "Hostos Community College",
  "Nassau Community College",
  "Suffolk County Community College",
  "Westchester Community College",
  "Rockland Community College",
  "Hudson Valley Community College",
  "Monroe Community College",
  "Onondaga Community College",
  "Erie Community College",
  "Community College of Philadelphia",
  "Montgomery County Community College",
  "Bucks County Community College",
  "Delaware County Community College",
  "Northern Virginia Community College",
  "Montgomery College",
  "Prince George's Community College",
  "Howard Community College",
  "Anne Arundel Community College",
  "Community College of Baltimore County",
  "Columbus State Community College",
  "Cuyahoga Community College",
  "Sinclair Community College",
  "Lorain County Community College",
  "Lakeland Community College",
  "Owens Community College",
  "Cincinnati State Technical and Community College",
  "Lansing Community College",
  "Grand Rapids Community College",
  "Oakland Community College",
  "Macomb Community College",
  "Washtenaw Community College",
  "Henry Ford College",
  "Schoolcraft College",
  "Mott Community College",
  "Delta College",
  "Kalamazoo Valley Community College",
  "Jackson College",
  "Lake Michigan College",
  "Kellogg Community College",
  "Southwestern Michigan College",
  "West Shore Community College",
  "Northwestern Michigan College",
  "North Central Michigan College",
  "Alpena Community College",
  "Gogebic Community College",
  "Bay de Noc Community College",
  "Monroe County Community College",
  "St. Clair County Community College",

  // United Kingdom
  "University of Oxford",
  "University of Cambridge",
  "Imperial College London",
  "University College London",
  "London School of Economics and Political Science",
  "University of Edinburgh",
  "King's College London",
  "University of Manchester",
  "University of Bristol",
  "University of Warwick",
  "University of Glasgow",
  "University of Birmingham",
  "University of Sheffield",
  "Queen Mary University of London",
  "University of Southampton",
  "University of Leeds",
  "University of Nottingham",
  "University of Liverpool",
  "University of York",
  "Durham University",
  "University of Exeter",
  "University of Sussex",
  "University of Bath",
  "University of Leicester",
  "Lancaster University",
  "Cardiff University",
  "University of Aberdeen",
  "University of St Andrews",
  "University of Reading",
  "University of East Anglia",
  "University of Strathclyde",
  "Newcastle University",
  "Queen's University Belfast",
  "University of Surrey",
  "Loughborough University",
  "Heriot-Watt University",
  "University of Dundee",
  "Swansea University",
  "Aberystwyth University",
  "Bangor University",
  "Brunel University London",
  "City, University of London",
  "Goldsmiths, University of London",
  "Keele University",
  "Oxford Brookes University",
  "Royal Holloway, University of London",
  "SOAS University of London",
  "University of Essex",
  "University of Kent",
  "University of Stirling",
  "Aston University",
  "University of Bradford",
  "University of Hull",
  "University of Portsmouth",
  "University of Salford",
  "University of Ulster",
  "University of Westminster",
  "Coventry University",
  "De Montfort University",
  "Edinburgh Napier University",
  "Glasgow Caledonian University",
  "Kingston University",
  "Liverpool John Moores University",
  "Manchester Metropolitan University",
  "Northumbria University",
  "Nottingham Trent University",
  "Sheffield Hallam University",
  "University of Brighton",
  "University of Central Lancashire",
  "University of Greenwich",
  "University of Hertfordshire",
  "University of Huddersfield",
  "University of Lincoln",
  "University of Plymouth",
  "University of the West of England",
  "University of Wolverhampton",

  // Canada
  "University of Toronto",
  "University of British Columbia",
  "McGill University",
  "McMaster University",
  "University of Alberta",
  "University of Montreal",
  "University of Calgary",
  "University of Ottawa",
  "University of Waterloo",
  "Western University",
  "Queen's University",
  "University of Victoria",
  "Simon Fraser University",
  "Dalhousie University",
  "Laval University",
  "University of Manitoba",
  "University of Saskatchewan",
  "University of Guelph",
  "York University",
  "Carleton University",
  "Concordia University",
  "University of New Brunswick",
  "University of Windsor",
  "Ryerson University",
  "University of Regina",
  "Memorial University of Newfoundland",
  "Université du Québec à Montréal",
  "University of Sherbrooke",
  "University of Lethbridge",
  "Wilfrid Laurier University",
  "Brock University",
  "Lakehead University",
  "Trent University",
  "University of Northern British Columbia",
  "University of Prince Edward Island",
  "University of Winnipeg",
  "Mount Allison University",
  "St. Francis Xavier University",
  "Acadia University",
  "Bishop's University",
  "Mount Royal University",
  "MacEwan University",
  "University of Ontario Institute of Technology",
  "Thompson Rivers University",
  "Vancouver Island University",
  "Kwantlen Polytechnic University",
  "University of the Fraser Valley",
  "Capilano University",
  "Emily Carr University of Art and Design",
  "OCAD University",

  // France
  "Sorbonne University",
  "Paris-Saclay University",
  "PSL Research University",
  "École Polytechnique",
  "École Normale Supérieure",
  "Sciences Po Paris",
  "University of Paris",
  "Aix-Marseille University",
  "University of Strasbourg",
  "University of Bordeaux",
  "University of Lyon",
  "University of Grenoble Alpes",
  "University of Montpellier",
  "University of Lille",
  "University of Toulouse",
  "University of Lorraine",
  "University of Rennes",
  "University of Nantes",
  "University of Nice Sophia Antipolis",
  "University of Poitiers",
  "University of Angers",
  "University of Burgundy",
  "University of Clermont Auvergne",
  "University of Orleans",
  "University of Tours",
  "University of Caen Normandy",
  "University of Rouen",
  "University of Le Havre",
  "University of Picardie Jules Verne",
  "University of Reims Champagne-Ardenne",
  "University of Franche-Comté",
  "University of Pau and the Adour Region",
  "University of Perpignan Via Domitia",
  "University of Toulon",
  "University of Corsica Pascal Paoli",
  "University of French Polynesia",
  "University of New Caledonia",
  "University of the French West Indies",
  "University of French Guiana",
  "University of Reunion Island",
  "École des Ponts ParisTech",
  "CentraleSupélec",
  "École Nationale Supérieure des Mines de Paris",
  "ESSEC Business School",
  "HEC Paris",
  "EDHEC Business School",
  "ESCP Business School",
  "EMLYON Business School",
  "KEDGE Business School",
  "NEOMA Business School",
  "SKEMA Business School",
  "Toulouse Business School",
  "Audencia Business School",
  "Grenoble École de Management",
  "ICN Business School",
  "Montpellier Business School",
  "Rennes School of Business",

  // Mexico
  "National Autonomous University of Mexico",
  "Tecnológico de Monterrey",
  "Universidad Iberoamericana",
  "Instituto Politécnico Nacional",
  "Universidad Autónoma Metropolitana",
  "Universidad de Guadalajara",
  "Universidad Autónoma de Nuevo León",
  "Universidad de las Américas Puebla",
  "Universidad Anáhuac",
  "Universidad Autónoma de Baja California",
  "Universidad Autónoma de San Luis Potosí",
  "Universidad Autónoma de Yucatán",
  "Universidad Veracruzana",
  "Universidad Michoacana de San Nicolás de Hidalgo",
  "Universidad Autónoma del Estado de México",
  "Universidad Autónoma de Querétaro",
  "Universidad de Guanajuato",
  "Universidad Autónoma de Sinaloa",
  "Universidad Autónoma de Chihuahua",
  "Universidad Autónoma de Ciudad Juárez",
  "Universidad de Sonora",
  "Universidad Autónoma de Coahuila",
  "Universidad Juárez Autónoma de Tabasco",
  "Universidad Autónoma de Tamaulipas",
  "Universidad Autónoma de Aguascalientes",
  "Universidad Autónoma de Zacatecas",
  "Universidad Autónoma de Tlaxcala",
  "Universidad Autónoma de Nayarit",
  "Universidad Autónoma de Campeche",
  "Universidad Autónoma del Estado de Morelos",
  "Universidad Autónoma de Chiapas",
  "Universidad Autónoma Benito Juárez de Oaxaca",
  "Universidad Autónoma de Guerrero",
  "Universidad Autónoma del Estado de Hidalgo",
  "Universidad Autónoma de Baja California Sur",
  "Universidad Autónoma de Quintana Roo",
  "Universidad Juárez del Estado de Durango",
  "Universidad Autónoma del Carmen",
  "Universidad Popular Autónoma del Estado de Puebla",
  "Universidad del Valle de México",
  "Universidad La Salle",
  "Instituto Tecnológico Autónomo de México",
  "Universidad Panamericana",
  "Universidad del Valle de Atemajac",
  "Universidad Regiomontana",
  "Universidad de Monterrey",
  "Universidad de Colima",
  "Universidad de Quintana Roo",
  "Universidad Autónoma de la Laguna",

  // Asia
  "Tsinghua University",
  "Peking University",
  "National University of Singapore",
  "University of Hong Kong",
  "Nanyang Technological University",
  "University of Tokyo",
  "Seoul National University",
  "Kyoto University",
  "Chinese University of Hong Kong",
  "Fudan University",
  "Shanghai Jiao Tong University",
  "Zhejiang University",
  "Korea Advanced Institute of Science and Technology",
  "Hong Kong University of Science and Technology",
  "Tokyo Institute of Technology",
  "Osaka University",
  "Yonsei University",
  "Korea University",
  "Sungkyunkwan University",
  "Indian Institute of Science",
  "Indian Institute of Technology Bombay",
  "Indian Institute of Technology Delhi",
  "National Taiwan University",

  // Europe
  "ETH Zurich",
  "EPFL (École Polytechnique Fédérale de Lausanne)",
  "Technical University of Munich",
  "Ludwig Maximilian University of Munich",
  "Heidelberg University",
  "KU Leuven",
  "Delft University of Technology",
  "University of Amsterdam",
  "Leiden University",
  "Utrecht University",
  "University of Copenhagen",
  "Karolinska Institute",
  "University of Helsinki",
  "University of Oslo",
  "University of Zurich",
  "University of Geneva",
  "University of Barcelona",
  "Autonomous University of Madrid",
  "Sapienza University of Rome",
  "University of Milan",
  "University of Bologna",
  "University of Vienna",
  "University of Warsaw",
  "Charles University",
  "University of Groningen",
  "Erasmus University Rotterdam",
  "Wageningen University & Research",
  "Vrije Universiteit Amsterdam",
  "Ghent University",
  "University of Gothenburg",
  "Uppsala University",
  "Stockholm University",
  "Aarhus University",
  "Technical University of Denmark",
  "University of Bern",
  "University of Basel",
  "University of Lausanne",
  "Trinity College Dublin",
  "University College Dublin",
  "University of Lisbon",
  "University of Porto",

  // Latin America
  "University of São Paulo",
  "University of Buenos Aires",
  "Pontifical Catholic University of Chile",
  "State University of Campinas",
  "Federal University of Rio de Janeiro",
  "University of Chile",

  // Africa & Middle East
  "University of Cape Town",
  "University of the Witwatersrand",
  "Stellenbosch University",
  "University of Johannesburg",
  "American University of Beirut",
  "Tel Aviv University",
  "Hebrew University of Jerusalem",
  "Technion – Israel Institute of Technology",
  "King Abdulaziz University",
  "King Saud University",
  "Qatar University",
  "United Arab Emirates University",
  "Cairo University",
  "University of Nairobi",
  "University of Ghana",

  // Additional international universities
  "University of Auckland",
  "University of Otago",
  "Victoria University of Wellington",
  "National University of Ireland, Galway",
  "University of Iceland",
  "University of Malta",
  "University of Cyprus",
  "University of Luxembourg",
  "University of Ljubljana",
  "University of Zagreb",
  "University of Belgrade",
  "University of Bucharest",
  "Sofia University",
  "University of Athens",
  "University of Crete",
  "University of Latvia",
  "University of Vilnius",
  "University of Tartu",
  "Tampere University",
  "Aalto University",
  "Norwegian University of Science and Technology",
  "University of Bergen",
  "Chalmers University of Technology",
  "Lund University",
  "KTH Royal Institute of Technology",
  "University of Turku",
  "University of Jyväskylä",
  "University of Oulu",
  "Aalborg University",
  "University of Southern Denmark",
  "University of Akureyri",
  "University of the Faroe Islands",
  "University of Greenland",
  "University of Nicosia",
  "European University Cyprus",
  "University of Liechtenstein",
  "University of Andorra",
  "University of San Marino",
  "University of Monaco",
  "University of Vatican City",
  "University of Gibraltar",
  "University of the Bahamas",
  "University of the West Indies",
  "University of the Virgin Islands",
  "University of Puerto Rico",
  "University of Guam",
  "University of the South Pacific",
  "University of Papua New Guinea",
  "University of the Philippines",
  "University of Santo Tomas",
  "Ateneo de Manila University",
  "De La Salle University",
  "University of Indonesia",
  "Bandung Institute of Technology",
  "Universitas Gadjah Mada",
  "Chulalongkorn University",
  "Mahidol University",
  "Thammasat University",
  "Vietnam National University, Hanoi",
  "Vietnam National University, Ho Chi Minh City",
  "University of Malaya",
  "Universiti Sains Malaysia",
  "Universiti Putra Malaysia",
  "Universiti Kebangsaan Malaysia",
  "Universiti Teknologi Malaysia",
  "University of Dhaka",
  "Bangladesh University of Engineering and Technology",
  "University of Colombo",
  "University of Peradeniya",
  "University of Moratuwa",
  "University of Karachi",
  "Quaid-i-Azam University",
  "Lahore University of Management Sciences",
  "University of Engineering and Technology, Lahore",
  "University of the Punjab",
  "University of Delhi",
  "University of Mumbai",
  "University of Calcutta",
  "University of Madras",
  "University of Hyderabad",
  "Jawaharlal Nehru University",
  "Banaras Hindu University",
  "Aligarh Muslim University",
  "University of Kashmir",
  "University of Jammu",
  "University of Allahabad",
  "University of Lucknow",
  "University of Rajasthan",
  "University of Kerala",
  "University of Mysore",
  "University of Pune",
  "University of Patna",
  "University of Calicut",
  "University of Baroda",
  "University of North Bengal",
  "University of Gour Banga",
];
